import React, { useContext } from "react"

import Heading from "src/components/Heading"

import Address from "../../Billing/InvoicePrintView/Address"
import { ContactInvoicesContext } from "../ContactInvoicesContextProvider"
import Footer from "./Footer"
import InvoicesTable from "./InvoicesTable"
import Summary from "./Summary"

const ContactInvoicesPrintView = () => {
  const { contact, marina, startDate, endDate, statusFilters, statusOptions } =
    useContext(ContactInvoicesContext)

  const readableStatusFilters = statusFilters.map((status) => {
    return statusOptions.find((opt) => opt.value === status)?.label || status
  })

  return (
    <div
      data-testid="contact-invoices-print-view"
      className="hidden print:block"
    >
      <div className="mt-6 flex flex-col space-y-4">
        <div className="flex flex-row justify-between">
          <div className="flex flex-col space-y-4">
            <Heading.PageTitle>Billing Summary</Heading.PageTitle>
            <div data-testid="contact-address">
              <div className="font-bold">CUSTOMER</div>
              <Address
                {...contact}
                showEmail={Boolean(contact.email)}
                showPhone={Boolean(contact.displayPhone)}
              />
            </div>
            <div className="py-6">
              <Summary />
            </div>
          </div>
          <div className="flex flex-col space-y-4">
            {marina.logoUrl ? (
              <div className="flex w-[200px] justify-end">
                <img src={marina.logoUrl} alt={`${marina.name} logo`} />
              </div>
            ) : null}
            <div className="text-right" data-testid="marina-address">
              <Address
                {...marina.address}
                {...marina}
                showPhone={Boolean(marina.displayPhone)}
              />
            </div>
          </div>
        </div>
        <InvoicesTable />
        <Footer
          startDate={startDate}
          endDate={endDate}
          statusFilters={readableStatusFilters}
        />
      </div>
    </div>
  )
}

export default ContactInvoicesPrintView
